import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackPromoLinkClickAction } from '../../actions/analytics';
import { NewbuildingLinksList } from '../../components/NewbuildingLinksList';
import { IPromoNewbuildingLink } from '../../types/promos/newbuildingLink';
import { TThunkDispatch } from '../../types/redux/thunk';

interface INewbuildingLinksListContainerProps {
  newbuildingCountLink?: string;
  newbuildingCountText: string;
  newbuildingLinks: IPromoNewbuildingLink[];
  promoId: string;
}

export const NewbuildingLinksListContainer: React.FC<INewbuildingLinksListContainerProps> = ({
  newbuildingCountLink,
  newbuildingCountText,
  newbuildingLinks,
  promoId,
}) => {
  const dispatch: TThunkDispatch = useDispatch();

  const handleNewbuildingCountLinkClick = React.useCallback(() => {
    dispatch(trackPromoLinkClickAction(promoId, 'to_listingjk'));
  }, [dispatch, promoId]);

  const handleNewbuildingLinkClick = React.useCallback(() => {
    dispatch(trackPromoLinkClickAction(promoId, 'to_jk'));
  }, [dispatch, promoId]);

  if (newbuildingLinks.length === 0) {
    return null;
  }

  return (
    <NewbuildingLinksList
      newbuildingCountText={newbuildingCountText}
      newbuildingCountLink={newbuildingCountLink}
      newbuildingLinks={newbuildingLinks}
      onNewbuildingCountLinkClick={handleNewbuildingCountLinkClick}
      onNewbuildingLinkClick={handleNewbuildingLinkClick}
    />
  );
};
